import jwt from 'jsonwebtoken';

// Function to decode and check the expiration
export const checkJWTExpiration = (token) => {
    const decoded = jwt.decode(token);

    if (!decoded) {
        return false;
    }

    const exp = decoded.exp;
    const currentTime = Math.floor(Date.now() / 1000); 
    return exp < currentTime;
}
